document.addEventListener("DOMContentLoaded", function () {
  const lpBottomSlider = new Swiper(".js-lpBottom-swiper", {
    slidesPerView: 1.15,
    spaceBetween: 0,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      800: {
        slidesPerView: 2.5,
        spaceBetween: 0,
        centeredSlides: true,
      },
    },
  });
});
